var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "coninput",
      staticClass: "vs-component vs-con-input-label vs-input",
      class: [
        `vs-input-${_vm.color}`,
        {
          isFocus: _vm.isFocus,
          "input-icon-validate-success": _vm.success,
          "input-icon-validate-danger": _vm.danger,
          "input-icon-validate-warning": _vm.warning,
          "is-label-placeholder": _vm.labelPlaceholder,
        },
      ],
      style: _vm.styleLabel,
    },
    [
      (_vm.labelPlaceholder ? false : _vm.label)
        ? _c(
            "label",
            {
              staticClass: "vs-input--label",
              attrs: { for: _vm.$attrs.id ? _vm.$attrs.id : "" },
              on: { click: _vm.focusInput },
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "vs-con-input" },
        [
          _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  ref: "vsinput",
                  staticClass: "vs-inputx vs-input--input",
                  class: [
                    _vm.size,
                    {
                      hasValue: _vm.value !== "",
                      hasIcon: _vm.icon,
                      "icon-after-input": _vm.iconAfter,
                    },
                  ],
                  style: _vm.style,
                  attrs: {
                    autofocus: _vm.autofocus,
                    placeholder: null,
                    type: _vm.$attrs.type ? _vm.$attrs.type : "text",
                  },
                  domProps: { value: _vm.value },
                },
                "input",
                _vm.$attrs,
                false
              ),
              _vm.listeners
            )
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "placeholderx" } }, [
            _vm.isValue && (_vm.labelPlaceholder || _vm.$attrs.placeholder)
              ? _c(
                  "span",
                  {
                    ref: "spanplaceholder",
                    staticClass: "input-span-placeholder vs-input--placeholder",
                    class: [
                      _vm.labelPlaceholder && _vm.size,
                      _vm.size,
                      {
                        "vs-placeholder-label": _vm.labelPlaceholder,
                      },
                    ],
                    style: _vm.styleLabel,
                    on: { click: _vm.focusInput },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$attrs.placeholder || _vm.labelPlaceholder) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.icon
            ? _c("vs-icon", {
                staticClass: "icon-inputx notranslate vs-input--icon",
                class: {
                  "icon-after": _vm.iconAfter,
                  "icon-no-border": _vm.iconNoBorder,
                },
                attrs: { iconPack: _vm.iconPack, icon: _vm.icon },
                on: { click: _vm.focusInput },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "icon-validate" } }, [
            _vm.success || _vm.danger || _vm.warning
              ? _c(
                  "span",
                  {
                    staticClass: "input-icon-validate vs-input--icon-validate",
                    class: { "icon-before": _vm.iconAfter },
                  },
                  [
                    _c("vs-icon", {
                      class: { "icon-before": _vm.iconAfter },
                      attrs: { iconPack: _vm.valIconPack, icon: _vm.getIcon },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            leave: _vm.leave,
          },
        },
        [
          _vm.success
            ? _c(
                "div",
                {
                  key: "success",
                  staticClass: "con-text-validation vs-input--text-validation",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "span-text-validation span-text-validation-success vs-input--text-validation-span",
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.successText) + "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm.danger
            ? _c(
                "div",
                {
                  key: "danger",
                  staticClass:
                    "con-text-validation span-text-validation-danger vs-input--text-validation-span",
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v("\n        " + _vm._s(_vm.dangerText) + "\n      "),
                  ]),
                ]
              )
            : _vm.warning
            ? _c(
                "div",
                {
                  key: "warning",
                  staticClass:
                    "con-text-validation span-text-validation-warning vs-input--text-validation-span",
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v("\n        " + _vm._s(_vm.warningText) + "\n      "),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.descriptionText
            ? _c(
                "div",
                {
                  key: "description",
                  staticClass:
                    "con-text-validation span-text-validation vs-input--text-validation-span",
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.descriptionText) + "\n      "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }